/* System defined core library */
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';

/* User defined library/components */
import { BootstrapParams } from '../../../bootstrap-params';
import { MetricApiService } from '../../scheduling/shared/services/metric-api.service';

/* User defined enums/constants */
import { LogLevel } from '../enums/scheduling.enum';


@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private bootstrapParams: BootstrapParams,
    private metricApiService: MetricApiService,
    private location: Location
  ) {

  }

  handleError(error: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    /* tslint:disable:no-console */
    console.error(error);
    /* tslint:enable:no-console */

    switch (true) {
      // API responses are already logged so we don't need to re-log them
      case error instanceof HttpErrorResponse: {
        break;
      }
      // webpack chunk errors will prevent component load
      case chunkFailedMessage.test(error.message): {
        this.metricApiService.log(LogLevel.Error, `error loading chunk: ${error}`);
        break;
      }
      default: {
        if (this.bootstrapParams.logConsoleToDB) {
          this.metricApiService.log(LogLevel.Debug, `error at ${this.location.path}: ${error}`);
        }
        break;
      }
    }
  }
}
